/* ============================================================
   BUONO — Shopify theme JS
   Carousels + sliders ported from the WooCommerce home.js, plus
   drawer (menu/cart), AJAX cart, product gallery & variant logic.
   No dependencies.
   ============================================================ */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var money = (window.Shopify && Shopify.formatMoney) ? null : null; // use theme setting below
  var MONEY_FORMAT = (window.bwTheme && window.bwTheme.moneyFormat) || '${{amount}}';

  function formatMoney(cents) {
    var value = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return MONEY_FORMAT.replace(/\{\{\s*amount\s*\}\}/g, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(cents / 100).toLocaleString());
  }

  /* ---------- horizontal carousel arrows (ported) ---------- */
  function itemStep(scroller) {
    var track = scroller.firstElementChild;
    var item = track && track.firstElementChild;
    if (!item) return scroller.clientWidth * 0.8;
    var cs = getComputedStyle(track);
    var gap = parseInt(cs.columnGap || cs.gap || '20', 10) || 20;
    return item.getBoundingClientRect().width + gap;
  }

  function initCarousels(root) {
    root = root || document;
    var groups = {};
    root.querySelectorAll('[data-carousel-prev],[data-carousel-next]').forEach(function (btn) {
      var isNext = btn.hasAttribute('data-carousel-next');
      var id = btn.getAttribute(isNext ? 'data-carousel-next' : 'data-carousel-prev');
      var scroller = document.getElementById(id);
      if (!scroller) return;
      btn.addEventListener('click', function () {
        scroller.scrollBy({ left: (isNext ? 1 : -1) * itemStep(scroller) * 2, behavior: 'smooth' });
      });
      var g = groups[id] || (groups[id] = { el: scroller, prev: null, next: null });
      if (isNext) { g.next = btn; } else { g.prev = btn; }
    });
    Object.keys(groups).forEach(function (id) {
      var g = groups[id];
      function sync() {
        var max = g.el.scrollWidth - g.el.clientWidth - 2;
        if (g.prev) g.prev.disabled = g.el.scrollLeft <= 2;
        if (g.next) g.next.disabled = g.el.scrollLeft >= max;
      }
      var tick;
      g.el.addEventListener('scroll', function () { window.cancelAnimationFrame(tick); tick = window.requestAnimationFrame(sync); });
      window.addEventListener('resize', sync);
      sync();
    });

    /* gentle auto-scroll, still swipeable */
    root.querySelectorAll('[data-autoscroll]').forEach(function (carousel) {
      if (carousel.dataset.bwBound) return; carousel.dataset.bwBound = '1';
      var paused = false, timer = null, resume;
      function advance() {
        if (paused) return;
        var max = carousel.scrollWidth - carousel.clientWidth - 2;
        if (carousel.scrollLeft >= max) { carousel.scrollTo({ left: 0, behavior: 'smooth' }); }
        else { carousel.scrollBy({ left: itemStep(carousel), behavior: 'smooth' }); }
      }
      function start() { if (!reduce && !timer && carousel.scrollWidth > carousel.clientWidth + 4) timer = window.setInterval(advance, 3500); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function hold() { paused = true; window.clearTimeout(resume); }
      function release() { window.clearTimeout(resume); resume = window.setTimeout(function () { paused = false; }, 4000); }
      ['pointerdown', 'touchstart', 'wheel'].forEach(function (e) { carousel.addEventListener(e, hold, { passive: true }); });
      ['pointerup', 'touchend'].forEach(function (e) { carousel.addEventListener(e, release, { passive: true }); });
      var wrap = carousel.closest('.bw-carousel-wrap') || carousel;
      wrap.addEventListener('mouseenter', hold);
      wrap.addEventListener('mouseleave', release);
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { e.isIntersecting ? start() : stop(); });
        }, { threshold: 0.2 }).observe(carousel);
      } else { start(); }
    });
  }

  /* ---------- one-per-view slider with dots (quality section) ---------- */
  function initQual(root) {
    (root || document).querySelectorAll('[data-qual]').forEach(function (slider) {
      if (slider.dataset.bwBound) return; slider.dataset.bwBound = '1';
      var section = slider.closest('.bw-qual') || slider.parentNode;
      var slides = slider.querySelectorAll('.bw-qual__slide');
      var dots = section.querySelectorAll('[data-qual-dot]');
      if (!slides.length) return;
      function current() { return Math.round(slider.scrollLeft / slider.clientWidth); }
      function goTo(i) { i = Math.max(0, Math.min(slides.length - 1, i)); slider.scrollTo({ left: i * slider.clientWidth, behavior: 'smooth' }); }
      var prevBtn = section.querySelector('[data-qual-prev]');
      var nextBtn = section.querySelector('[data-qual-next]');
      function syncDots() {
        var i = current();
        dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
        if (prevBtn) prevBtn.disabled = i <= 0;
        if (nextBtn) nextBtn.disabled = i >= slides.length - 1;
      }
      dots.forEach(function (d) { d.addEventListener('click', function () { goTo(parseInt(d.getAttribute('data-qual-dot'), 10) || 0); }); });
      if (prevBtn) prevBtn.addEventListener('click', function () { goTo(current() - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goTo(current() + 1); });
      var tick;
      slider.addEventListener('scroll', function () { window.cancelAnimationFrame(tick); tick = window.requestAnimationFrame(syncDots); }, { passive: true });
      var paused = false, timer = null, resume;
      function advance() { if (paused) return; var next = current() + 1; goTo(next >= slides.length ? 0 : next); }
      function start() { if (!reduce && !timer) timer = window.setInterval(advance, 4500); }
      function stop() { if (timer) { window.clearInterval(timer); timer = null; } }
      function hold() { paused = true; window.clearTimeout(resume); }
      function release() { window.clearTimeout(resume); resume = window.setTimeout(function () { paused = false; }, 6000); }
      ['pointerdown', 'touchstart', 'mouseenter', 'wheel'].forEach(function (e) { slider.addEventListener(e, hold, { passive: true }); });
      ['pointerup', 'touchend', 'mouseleave'].forEach(function (e) { slider.addEventListener(e, release, { passive: true }); });
      window.addEventListener('resize', syncDots);
      syncDots();
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { entries.forEach(function (e) { e.isIntersecting ? start() : stop(); }); }, { threshold: 0.3 }).observe(slider);
      } else { start(); }
    });
  }

  /* ---------- drawers (menu + cart) ---------- */
  var overlay;
  function ensureOverlay() {
    overlay = document.querySelector('.bw-overlay');
    if (!overlay) { overlay = document.createElement('div'); overlay.className = 'bw-overlay'; document.body.appendChild(overlay); }
    return overlay;
  }
  function openDrawer(el) {
    if (!el) return;
    ensureOverlay().classList.add('is-open');
    el.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    overlay.onclick = closeDrawers;
  }
  function closeDrawers() {
    document.querySelectorAll('.bw-drawer.is-open').forEach(function (d) { d.classList.remove('is-open'); });
    if (overlay) overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  function bindGlobalControls() {
    document.querySelectorAll('[data-open-cart]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); refreshCart().then(function () { openDrawer(document.getElementById('bw-cart-drawer')); }); });
    });
    document.querySelectorAll('[data-open-menu]').forEach(function (b) {
      b.addEventListener('click', function (e) { e.preventDefault(); openDrawer(document.getElementById('bw-menu-drawer')); });
    });
    document.querySelectorAll('[data-close-drawer]').forEach(function (b) { b.addEventListener('click', closeDrawers); });
    // mobile drawer accordion submenus
    document.querySelectorAll('[data-mtoggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var sub = btn.nextElementSibling;
        var open = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!open));
        if (sub) sub.hidden = open;
      });
    });
    document.querySelectorAll('[data-toggle-search]').forEach(function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var s = document.getElementById('bw-search');
        if (s) { s.classList.toggle('is-open'); var inp = s.querySelector('input[type="search"]'); if (inp && s.classList.contains('is-open')) inp.focus(); }
      });
    });
  }

  /* ---------- AJAX cart ---------- */
  function getCart() { return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }); }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.hidden = cart.item_count === 0;
    });
    var body = document.getElementById('bw-cart-body');
    var foot = document.getElementById('bw-cart-foot');
    if (!body) return;
    if (!cart.items.length) {
      body.innerHTML = '<div class="bw-cart__empty">Your cart is empty.</div>';
      if (foot) foot.innerHTML = '';
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') + '" alt="' + escapeHtml(it.product_title) + '">' : '';
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="bw-cartline__variant">' + escapeHtml(it.variant_title) + '</div>' : '';
      return '<div class="bw-cartline" data-key="' + it.key + '">' +
        '<a class="bw-cartline__img" href="' + it.url + '">' + img + '</a>' +
        '<div>' +
          '<div class="bw-cartline__name"><a href="' + it.url + '">' + escapeHtml(it.product_title) + '</a></div>' +
          variant +
          '<div class="bw-qty" data-line-qty>' +
            '<button type="button" data-qty-dec aria-label="Decrease">&minus;</button>' +
            '<input type="text" inputmode="numeric" value="' + it.quantity + '" data-qty-input aria-label="Quantity">' +
            '<button type="button" data-qty-inc aria-label="Increase">+</button>' +
          '</div>' +
          '<button type="button" class="bw-cartline__remove" data-qty-remove>Remove</button>' +
        '</div>' +
        '<div class="bw-cartline__price">' + formatMoney(it.final_line_price) + '</div>' +
      '</div>';
    }).join('');
    if (foot) {
      foot.innerHTML =
        '<div class="bw-cart__subtotal"><span>Subtotal</span><span>' + formatMoney(cart.total_price) + '</span></div>' +
        '<p class="bw-cart__note">Shipping &amp; taxes calculated at checkout.</p>' +
        '<a href="/checkout" class="bw-btn bw-btn--full">Checkout</a>';
    }
    bindCartLineEvents();
  }

  function bindCartLineEvents() {
    document.querySelectorAll('.bw-cartline').forEach(function (line) {
      var key = line.getAttribute('data-key');
      var input = line.querySelector('[data-qty-input]');
      function change(q) { updateCart(key, Math.max(0, q)); }
      var inc = line.querySelector('[data-qty-inc]');
      var dec = line.querySelector('[data-qty-dec]');
      var rem = line.querySelector('[data-qty-remove]');
      if (inc) inc.addEventListener('click', function () { change(parseInt(input.value, 10) + 1); });
      if (dec) dec.addEventListener('click', function () { change(parseInt(input.value, 10) - 1); });
      if (rem) rem.addEventListener('click', function () { change(0); });
      if (input) input.addEventListener('change', function () { change(parseInt(input.value, 10) || 0); });
    });
  }

  function updateCart(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    }).then(function (r) { return r.json(); }).then(renderCart);
  }

  function refreshCart() { return getCart().then(renderCart); }

  function addToCart(form, openAfter) {
    var btn = form.querySelector('[type="submit"]');
    var data = new FormData(form);
    if (btn) { btn.disabled = true; btn.dataset.label = btn.textContent; btn.textContent = 'Adding…'; }
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) { throw new Error(res.body.description || 'Could not add to cart'); }
        return refreshCart();
      })
      .then(function () { if (openAfter !== false) openDrawer(document.getElementById('bw-cart-drawer')); })
      .catch(function (err) { alert(err.message); })
      .finally(function () { if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; } });
  }

  function bindAddToCartForms() {
    document.querySelectorAll('form[data-ajax-cart]').forEach(function (form) {
      if (form.dataset.bwBound) return; form.dataset.bwBound = '1';
      form.addEventListener('submit', function (e) { e.preventDefault(); addToCart(form, true); });
    });
  }

  function escapeHtml(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }

  /* ---------- product page: gallery + variants ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-product]').forEach(function (scope) {
      if (scope.dataset.bwBound) return; scope.dataset.bwBound = '1';

      // prescription toggle — show Rx fields on "Yes"; disabled fields don't submit on "No"
      var rxFields = scope.querySelector('[data-rx-fields]');
      if (rxFields) {
        var setRx = function (on) {
          rxFields.hidden = !on;
          rxFields.querySelectorAll('[data-rx-input]').forEach(function (i) { i.disabled = !on; });
        };
        setRx(false);
        scope.querySelectorAll('[data-rx-toggle]').forEach(function (r) {
          r.addEventListener('change', function () { setRx(r.getAttribute('data-rx-toggle') === 'on'); });
        });
      }

      // gallery thumbs
      var main = scope.querySelector('[data-gallery-main]');
      scope.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          if (main && full) main.src = full;
          scope.querySelectorAll('[data-gallery-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        });
      });
      // variants
      var dataEl = scope.querySelector('[data-variant-json]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = scope.querySelector('form[data-ajax-cart]');
      var idInput = form && form.querySelector('[name="id"]');
      var priceEl = scope.querySelector('[data-price]');
      var cmpEl = scope.querySelector('[data-compare]');
      var addBtn = form && form.querySelector('[type="submit"]');
      function selectedOptions() {
        var opts = [];
        scope.querySelectorAll('[data-option-index]').forEach(function (group) {
          var i = parseInt(group.getAttribute('data-option-index'), 10);
          var checked = group.querySelector('input:checked') || group.querySelector('select');
          opts[i] = checked ? checked.value : null;
        });
        return opts;
      }
      function update() {
        var sel = selectedOptions();
        var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === sel[i]; }); });
        if (!match) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.innerHTML = formatMoney(match.price);
        if (cmpEl) { cmpEl.innerHTML = (match.compare_at_price && match.compare_at_price > match.price) ? formatMoney(match.compare_at_price) : ''; }
        if (addBtn) { addBtn.disabled = !match.available; addBtn.textContent = match.available ? 'Add to cart' : 'Sold out'; }
      }
      scope.querySelectorAll('[data-option-index] input,[data-option-index] select').forEach(function (el) {
        el.addEventListener('change', update);
      });
      update();
    });
  }

  /* ---------- newsletter via Shopify customer form is server-rendered;
       nothing to bind here unless using a custom endpoint ---------- */

  function initAll(root) {
    initCarousels(root);
    initQual(root);
    bindAddToCartForms();
    initProduct(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindGlobalControls();
    initAll(document);
    refreshCart();
  });

  // Re-init when a section is edited in the theme editor
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); bindGlobalControls(); });
  document.addEventListener('shopify:section:select', function (e) {
    if (e.target.querySelector('#bw-cart-drawer')) return;
  });

  window.bwTheme = window.bwTheme || {};
  window.bwTheme.refreshCart = refreshCart;
  window.bwTheme.openCart = function () { refreshCart().then(function () { openDrawer(document.getElementById('bw-cart-drawer')); }); };
})();
